'use client';

import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { SurveyComponentProps } from './survey.component';
import dynamic from 'next/dynamic';

const DynamicSurveyComponent: ComponentType<SurveyComponentProps> = dynamic(
  () => import('./survey.component')
);

export default DynamicSurveyComponent;

export function calculateSurveyPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 0 },
    { sinceWidth: 0, height: 0 },
    { sinceWidth: 0, height: 0 }
  ];

  return {
    heightSinceWidth
  };
}
